import logo from './uber-rewards-tap-network-logo.svg';
import favicon from './uber-favicon.ico';

export default { logo, favicon };
